import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {},
  actions: {
    margin: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))
